/* Copyright (c) 2026 Xperi. All Rights Reserved. */

import type { PayloadAction } from "@reduxjs/toolkit";

import { INITIAL_STATE } from "../signIn.state";
import type { SignInState } from "../signIn.types";

/**
 * Case reducers for the sign-in form itself: the tab selection, the
 * credential inputs and the code/QR fields the DBS screen displays.
 */
export const signInFormReducers = {
  setActiveTab(state: SignInState, action: PayloadAction<string>): void {
    state.activeTab = action.payload;
    state.focusedField = "tab";
  },
  setUserId(state: SignInState, action: PayloadAction<string>): void {
    state.userId = action.payload;
  },
  setPassword(state: SignInState, action: PayloadAction<string>): void {
    state.password = action.payload;
  },
  togglePasswordVisibility(state: SignInState): void {
    state.isPasswordVisible = !state.isPasswordVisible;
  },
  setAuthCode(state: SignInState, action: PayloadAction<string>): void {
    state.authCode = action.payload;
  },
  setQrCodeUrl(state: SignInState, action: PayloadAction<string>): void {
    state.qrCodeUrl = action.payload;
  },
  setMobileDialogDismissed(
    state: SignInState,
    action: PayloadAction<boolean>
  ): void {
    state.mobileDialogDismissed = action.payload;
  },
  /**
   * Clears a surfaced sign-in error without resetting the rest of the form.
   *
   * Dismissing the error alert has to clear both halves, or the effect that
   * watches `signInError` re-raises the same alert on the next render and the
   * user cannot get back to the form (UAW-2416 AC-3).
   */
  clearSignInError(state: SignInState): void {
    state.signInError = "";
    state.signInErrorCode = "";
    state.signInErrorServiceCode = "";
  },
  resetSignInState(): SignInState {
    return INITIAL_STATE;
  }
};
